module.exports = __webpack_public_path__ + "static/media/connector-line_curve-lg.6f770cb8.svg";